import { useI18n } from 'builder/hooks/useI18n'

import { BannerActions } from '../Banners/BannerActions/BannerActions'
import { useResumeWriting } from './hooks/useResumeWriting'
import { TRANSLATION } from './constants'

export const ResumeWritingActions = () => {
  const { i18n } = useI18n()
  const { closeBanner, handleResumeWritingPromo } = useResumeWriting()

  return (
    <BannerActions
      approveButtonText={i18n.t(`${TRANSLATION}.actions.resume_writing`)}
      rejectButtonText={i18n.t(`${TRANSLATION}.actions.next_step`)}
      rejectButtonClick={closeBanner}
      approveButtonClick={handleResumeWritingPromo}
    />
  )
}
